module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('ThroughNotifications', {

		configure: function(options) {
			this.referenceData = {};

			this.registerOptions('', {
				doNotTrackPosNote: false,
				widgets: {
					throughNotificationsContainer: {
						widget: 'Widget',
						'embed.container': '.mc-through-notifications-container',
						autoRender: true,
						template: 'throughnotification_global_body',
						'widgets.notices': {
							widget: 'AdvancedList',
							'embed.container': '.list',
							'tpl.row': 'new_notice',
							'handleDom.closeNotice': {
								event: 'click',
								target: '.notice-close',
								callback: '@parent @parent:_removeNotification'
							}
						},

						handleWom: {
							onAddedToDom: {
								widget: '@parent .Widget',
								event: "addedToDom",
								callback: fox.bind(function () {
									if (!this.getOption('doNotTrackPosNote')) {
										this.handleScrolling({top: (window.scrollY || window.pageYOffset)});
									}
								}, this)
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.containerWidget = this.getContainerWidget();
			this.listWidget = this.getListWidget();

			this._defaultTemplate = fox.clone(this.listWidget.getOption('tpl.row'));

			if (!this.getOption('doNotTrackPosNote')) {
				this.handleEvent(this.wom1('@parent @parent #windowScrollHandler'), 'scrolling', this.handleScrolling, {prefix: 'notifications'});
			}

			this.callParent('running', arguments);
		},

		getContainerWidget: function () {
			return this.wom1('#throughNotificationsContainer');
		},

		getListWidget: function () {
			return this.getContainerWidget().wom1('#notices');
		},

		setListTemplate: function (tpl) {
			this.getListWidget().setOption('tpl.row', tpl);
		},

		resetListTemplate: function (tpl) {
			this.getListWidget().setOption('tpl.row', this._defaultTemplate);
		},

		pushNotification: function (params) {
			var noticeList = this.getListWidget();
			var alias = params.noticeAlias;

			if (!alias) {
				console.warn('notice alias is required');

				return;
			}

			this.resetListTemplate();

			if (params.noticeTemplate) {
				this.setListTemplate(params.noticeTemplate);
			}

			if (params.listenWidgetDeactivate) {
				this.addDeactivateHandler(params.listenWidgetDeactivate, alias);
			}

			if (this.referenceData[alias]) {

				this.updateNotification(alias, {
					type: params.noticeType,
					message: params.noticeMessage
				});

			} else {

				this.addNotification(alias, {
					type: params.noticeType,
					message: params.noticeMessage
				});

			}

			if (fox.isNumeric(params.delayClose)) {
				alias = fox.clone(alias);

				window.setTimeout(fox.bind(function () {
					this.pullNotification(alias);
				}, this), params.delayClose);
			}
		},

		pullNotification: function (alias) {
			var noticeList = this.getListWidget();
			var id  = this.getReferenceDataByAlias(alias);

			if (!id) {
				return;
			}

			var ind = this.getItemIndexById(id);

			$(noticeList.getRowNode(ind)).addClass('slide-up');

			window.setTimeout(fox.bind(function () {
				noticeList.remove(ind);
				this.removeNotification(alias);
			}, this), 500);
		},

		pullAllNotifications: function (argument) {
			fox.each(this.referenceData, function (val, alias) {
				this.pullNotification(alias);
			}, this);
		},

		updateNotification: function (alias, params) {
			var data = params;

			data.alias = alias;

			this.getListWidget().updateItem(data, this.getItemIndexById(this.referenceData[alias]));
		},

		addNotification: function (alias, params) {
			var data = params;

			data.alias = alias;

			this.getListWidget().appendItem(data);
			this.setReferenceData(alias);
		},

		removeNotification: function (alias) {
			var id = this.referenceData[alias];

			if (id) {
				delete this.referenceData[alias];
			}
		},

		_removeNotification: function (el) {
			this.pullNotification(fox.dom.wrap(el).attr('data-item-alias'));
		},

		handleScrolling: function (offset) {
			var y = offset.top,
				hHeight = this.getHeaderHeight();

			offset = y - hHeight;

			if (y < hHeight) {
				offset = 10;
			}

			this.setContainerOffsetTop(offset);
		},

		setContainerOffsetTop: function (offset) {
			$(this.getContainerWidget().element[0]).css('marginTop', offset + 'px');
		},

		setReferenceData: function (alias) {
			var dataModel = this.getListWidget().dataModel;
			var id;

			if (dataModel.length === 0) {
				this.referenceData[alias] = 1;

				return;
			}

			this.referenceData[alias] = dataModel[(dataModel.length - 1)]._id;
		},

		getReferenceData: function () {
			return this.referenceData;
		},

		getReferenceDataByAlias: function (alias) {
			if (!alias) {
				return;
			}

			return this.referenceData[alias] || null;
		},

		getItemIndexById: function (id) {
			var result = this.getListWidget().getDataById(id);

			return (result !== false ? result.indx : result);
		},

		addDeactivateHandler: function (w, noticeAlias) {
			this.handleEvent(w, 'deactivate', fox.bind(function (wAlias) {
				this.pullNotification(noticeAlias);
			}, this), {once: true, prefix: 'notificationRemove'});
		},

		getHeaderHeight: function (argument) {
			return this.wom1('@parent').getHeight();
		}

	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/throughNotifications.js
// module id = 225
// module chunks = 0